module.exports = __webpack_public_path__ + "img/maneggio.5b0b3c06.jpg";